"use client";

import React from "react";
import { cn } from "utils";
import type { AssetInfo } from "../types";
import { NextImage } from "@components/NextImage";
import { PortfolioManage } from "@components/PortfolioManage";

export interface HoldingTableCellAssetProps {
  /** 资产信息 */
  asset: AssetInfo;
  /** 根节点类名 */
  className?: string;
  /** 名称、代码两行文案的类名（如列表表可传 line-clamp-1 md:w-40 w-22 做截断） */
  textClassName?: string;
}

/**
 * 持仓相关表格的 Asset 列单元格内容
 * 供 HoldingListTable、HoldingChangeTable 共用，保证第一列展示一致
 */
export const HoldingTableCellAsset: React.FC<HoldingTableCellAssetProps> = ({
  asset,
  className,
  textClassName,
}) => (
  <div className={cn("flex items-center gap-1", className)}>
    {asset.id ? (
      <div className="flex-shrink-0 min-w-4">
        <PortfolioManage
          id={asset.id}
          type="STOCK"
          zIndex={1000}
          clickContainerClassName="w-6 h-6"
        />
      </div>
    ) : (
      <span className="flex-shrink-0 min-w-6 w-6 h-6 invisible" aria-hidden />
    )}
    <div className="size-6 rounded-full border border-border_solid overflow-hidden flex-shrink-0">
      <NextImage
        src={asset.logo}
        alt={asset.symbol}
        width={24}
        height={24}
        className="size-full object-cover"
      />
    </div>
    <div className="flex flex-col min-w-0 overflow-hidden">
      <span
        className={cn(
          "body_medium_m text-content_primary min-w-0",
          textClassName,
        )}
        title={asset.name}
      >
        {asset.name || "--"}
      </span>
      <span
        className={cn("body_s text-content_tertiary min-w-0", textClassName)}
        title={asset.symbol}
      >
        {asset.symbol || "--"}
      </span>
    </div>
  </div>
);
